import { AgentEndpoints, RequestMethods, useRequest } from '@src/shared';
import type { CommonResponse } from '@src/shared/types';

import type { GetProfileResponse } from './get-profile.types';

export const useGetProfile = (
  fetchManual = true,
  key: string = 'getProfile'
) => {
  const { res, isLoading, refetch, error, status, isFetching } = useRequest<
    never,
    GetProfileResponse,
    CommonResponse
  >({
    params: {
      key,
      method: RequestMethods.GET,
      url: `${AgentEndpoints.AGENTS}/profile`,
      fetchManual,
    },
  });

  return {
    res,
    error,
    isLoading,
    refetch,
    status,
    isFetching,
  };
};
